import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Frame, Toast } from '@shopify/polaris';
import { setStore, setToast } from "./store/slices/appSlice";
import { getDomain, getStore } from './controller';
import { Provider } from '@shopify/app-bridge-react';
import AppRouter from './routes';
import './App.css';

function App() {
  const app = useSelector(state => state.app)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const domain = getDomain()
    if (domain && domain !== "") {
      (async () => {
        setLoading(true)
        const store = await getStore(domain);
        dispatch(setStore(store.success ? store.store : {}))
        setLoading(false)
      })()
    }

  }, [])
  let host = new URLSearchParams(window.location.search).get('host')
  return (
    <Provider config={{ "apiKey": app.apikey, "host": host ? host : app.store.shopifyHost }}>
      {
        loading ? null : <Frame>
          <AppRouter />
          {app.toast.active ? <Toast content={app.toast.content} error={app.toast.error} onDismiss={() => dispatch(setToast())} /> : null}
        </Frame>
      }
    </Provider>
  );
}

export default App;
